import { useContext, useEffect, useMemo, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  FormControlLabel,
  Switch,
  Checkbox,
  Icon,
  DialogTitle,
  InputAdornment,
} from "@material-ui/core";
import { ExpandMore, Close, Add, Edit } from "@material-ui/icons";

import Btn from "../../../../components/buttons/Btn";
import Chip from "../../../../components/basics/Chip";
import CircularLoader from "../../../../components/loading/circularLoader";
import { GridStyled, LabelStyled } from "../../../../theme/styles/Layout";
import { TypographyStyled } from "../../../../theme/styles/Layout";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import Card from "../../../../components/cards/Card";
import { TriagemContratoContext } from "../contexts/TriagemContratoContext";
import { formatDate } from "../../../../utils/formatDate";
import useTriagemContratoController from "../controllers/TriagemContratoController";
import { notify } from "../../../../utils/notify";
import { CardItemContract } from "./CardItemContract";
import { findProposal } from "../../../../repositories/qerpapi/v3/faturamento/ContratoRepository";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import ModalCadastroDescricao from "../../../../patterns/modals/modalCadastroDescricao/ModalCadastroDescricao";
import MaskService from "../../../../utils/mask/maskService";
import { confirmLookupEdit } from "../../../../utils/confirmLookupEdit";
import moment from "moment";

const ModalDetailTriagem = ({ idProposal }) => {
  const [accordionsOpen, setAccordionsOpen] = useState({
    avulso: false,
    recorrente: false,
  });

  const {
    returnCompetencyAndVigency,
    handleScheduling,
    handleSubmit,
    handleClearContext,
    getPaymentWay,
    getReadjustment,
    getPaymentType,
    getContractType,
    getBank,
    getService,
    getLeadOriginList,
    getSaleTypeList,
    handleLeadOriginSaved,
    handleSaleTypeSaved,
    storeLeadOrigin,
    updateLeadOrigin,
    storeSaleType,
    updateSaleType,
    getBillingRuler,
  } = useTriagemContratoController();

  const {
    setSingleFirstInstallment,
    singleServiceType,
    setSingleServiceType,
    singleRegimeCompetence,
    setSingleRegimeCompetence,
    singleCompetenceDate,
    setSingleCompetenceDate,
    singleBank,
    setSingleBank,
    singlePaymentType,
    setSinglePaymentType,
    singlePaymentWay,
    setSinglePaymentWay,
    singleSlipType,
    setSingleSlipType,
    singleNfse,
    setSingleNfse,
    singleBillingRuler,
    setSingleBillingRuler,

    recurrentServiceType,
    setRecurrentServiceType,
    recurrentFirstMonthlyDate,
    setRecurrentFirstMonthlyDate,
    recurrentExpirationDay,
    setRecurrentExpirationDay,
    recurrentReadjustment,
    setRecurrentReadjustment,
    recurrentRegimeCompetence,
    setRecurrentRegimeCompetence,
    recurrentCompetenceDate,
    setRecurrentCompetenceDate,
    recurrentValidityDate,
    setRecurrentValidityDate,
    recurrentBank,
    setRecurrentBank,
    recurrentPaymentType,
    setRecurrentPaymentType,
    recurrentFrequency,
    setRecurrentFrequency,
    recurrentSlipType,
    setRecurrentSlipType,
    recurrentNfse,
    setRecurrentNfse,
    recurrentBillingRuler,
    setRecurrentBillingRuler,

    proposalCode,
    setProposalCode,
    revisionDate,
    setRevisionDate,
    contractTypeList,
    bankList,
    paymentTypeList,
    readjustmentList,
    paymentWayList,
    billingRulerList,
    rowEdit,
    setRowEdit,
    errors,
    variablesModule,
    loadingsInputs,
    originProposal,
    setOriginProposal,
    financialResponsibleEnabled,
    setFinancialResponsibleEnabled,
    financialResponsibleInfos,
    setFinancialResponsibleInfos,
    leadOrigin,
    setLeadOrigin,
    listLeadOrigin,
    saleType,
    setSaleType,
    listSaleType,
    salesmanInfos,
    setSalesmanInfos,
    generatedInstallments,
    setGeneratedInstallments,
  } = useContext(TriagemContratoContext);
  const [proposalCrm, setProposalCrm] = useState({});
  const [loadingModal, setLoadingModal] = useState(false);
  const [modalFinancialResponsibleOpen, setModalFinancialResponsibleOpen] =
    useState(false);
  const [modalLeadOriginOpen, setModalLeadOriginOpen] = useState(false);
  const [modalSaleTypeOpen, setModalSaleTypeOpen] = useState(false);
  const [modalSalesmanOpen, setModalSalesmanOpen] = useState(false);
  const [leadOriginEditItem, setLeadOriginEditItem] = useState(null);
  const [saleTypeEditItem, setSaleTypeEditItem] = useState(null);

  const [competenceList] = useState([
    {
      label: "Competência e Vencimento no mesmo mês",
      value: "atual",
    },
    {
      label: "Competência em mês anterior ao Vencimento",
      value: "anterior",
    },
    {
      label: "Competência em mês posterior ao Vencimento",
      value: "posterior",
    },
  ]);

  const [slipTypesList] = useState([
    { label: "HÍBRIDO", value: "hibrido" },
    { label: "CNAB", value: "cnab" },
    { label: "PIX", value: "pix" },
  ]);

  const [frequencyList] = useState([
    { label: "Mensal", value: 1 },
    { label: "Bimestral", value: 2 },
    { label: "Trimestral", value: 3 },
    { label: "Semestral", value: 6 },
    { label: "Anual", value: 12 },
  ]);

  const proposoalTotal = useMemo(() => {
    const sum = (proposalCrm?.proposal_products || []).reduce((acc, item) => {
      if (item?.integration_details?.tiposervico === "A") {
        return acc + parseFloat(item?.total_value_with_discount || 0);
      }

      return acc + 0;
    }, 0);

    return parseFloat(sum.toFixed(2));
  }, [proposalCrm]);

  useEffect(() => {
    setSingleServiceType(null);
    setSingleSlipType(slipTypesList[1]);
    setSingleRegimeCompetence(competenceList[0]);

    setRecurrentServiceType(null);
    setRecurrentSlipType(slipTypesList[1]);
    setRecurrentRegimeCompetence(competenceList[0]);
    setRecurrentFrequency(frequencyList[0]);
  }, [
    slipTypesList,
    competenceList,
    frequencyList,
    setSingleServiceType,
    setRecurrentServiceType,
    setSingleNfse,
    setSingleSlipType,
    setRecurrentSlipType,
    setRecurrentRegimeCompetence,
    setSingleRegimeCompetence,
    setRecurrentNfse,
    setRecurrentFrequency,
  ]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingModal(true);

        const response = await findProposal({ id: idProposal });

        if (!response.success) {

          if(response.internalCode === 4000) {
            return notify(response.message);
          }

          notify(
            `Não foi possível obter a proposta de Id (${idProposal}).`
          );

          return;
        }

        const data = response.data;

        setProposalCrm(data);
        setSaleType(data?.sale_type);
        setLeadOrigin(data?.lead_origin);
        setSalesmanInfos(data?.salesman);
        setProposalCode(data?.original_proposal_code  ? `${data?.original_proposal_code}` : `${data?.proposta_crm_id}`);
        setOriginProposal(data?.origin_crm_id === 2 ? "Nectar" : "Geiko");

        let hasTypes = "";

        for (const p of data?.proposal_products || []) {
          if (
            !hasTypes.includes("A") &&
            p?.integration_details?.tiposervico === "A"
          ) {
            hasTypes += "A";
          }

          if (
            !hasTypes.includes("R") &&
            p?.integration_details?.tiposervico === "R"
          ) {
            hasTypes += "R";
          }

          if (hasTypes.length > 1) break;
        }

        const valueAccordionOpen = {
          AR: {
            avulso: true,
            recorrente: false,
          },
          RA: {
            avulso: true,
            recorrente: false,
          },
          A: {
            avulso: true,
            recorrente: false,
          },
          R: {
            avulso: false,
            recorrente: true,
          },
        };

        setAccordionsOpen(
          valueAccordionOpen[hasTypes] || {
            avulso: false,
            recorrente: false,
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingModal(false);
      }
    })();
  }, [
    idProposal,
    setProposalCode,
    setOriginProposal,
    setSaleType,
    setLeadOrigin,
    setSalesmanInfos,
  ]);

  useEffect(() => {
    if (!proposalCrm?.firs_due_date) return setSingleFirstInstallment("");

    const firstDate = formatDate({
      date: new Date(proposalCrm?.firs_due_date),
      separator: "-",
      format: "yyyy-mm-dd",
    });

    setSingleFirstInstallment(firstDate || "");
  }, [setSingleFirstInstallment, proposalCrm]);

  useEffect(() => {
    let newDate = new Date(proposalCrm?.first_recurrent_payment);

    if (!newDate) {
      newDate = new Date();
    }

    setRecurrentFirstMonthlyDate(
      formatDate({ date: newDate, separator: "-", format: "yyyy-mm-dd" })
    );

    setRecurrentExpirationDay(newDate.getDate().toString());
  }, [setRecurrentFirstMonthlyDate, setRecurrentExpirationDay, proposalCrm]);

  useEffect(() => {
    const response = returnCompetencyAndVigency("single");

    if (!response) return;

    const { competenceDate } = response;

    setSingleCompetenceDate(competenceDate);
  }, [
    recurrentRegimeCompetence,
    returnCompetencyAndVigency,
    setRecurrentCompetenceDate,
    setRecurrentValidityDate,
    setSingleCompetenceDate,
  ]);

  useEffect(() => {
    const response = returnCompetencyAndVigency("recurrent");

    if (!response) return;

    const { competenceDate, validityDate } = response;

    setRecurrentCompetenceDate(competenceDate);
    setRecurrentValidityDate(validityDate);
  }, [
    recurrentRegimeCompetence,
    returnCompetencyAndVigency,
    setRecurrentCompetenceDate,
    setRecurrentValidityDate,
  ]);

  useEffect(() => {
    getContractType();
  }, [getContractType]);

  useEffect(() => {
    getService();
  }, [getService]);

  useEffect(() => {
    getBank();
  }, [getBank]);

  useEffect(() => {
    getLeadOriginList();
  }, [getLeadOriginList]);

  useEffect(() => {
    getSaleTypeList();
  }, [getSaleTypeList]);

  useEffect(() => {
    getPaymentType();
  }, [getPaymentType]);

  useEffect(() => {
    getReadjustment();
  }, [getReadjustment]);

  useEffect(() => {
    getPaymentWay(proposalCrm);
  }, [getPaymentWay, proposalCrm]);

  useEffect(() => {
    getBillingRuler();
  }, [getBillingRuler]);

  useEffect(() => {
    if (!proposoalTotal || !singlePaymentWay?.qtdepagtos) return;

    const numberOfInstallments = singlePaymentWay?.qtdepagtos;

    let newInstallments = [];

    let index = 0;

    const installmentValue = parseFloat(
      (proposoalTotal / numberOfInstallments).toFixed(2)
    );

    let distributedSum = 0;

    for (let i = numberOfInstallments; i >= 1; i--) {
      if (i !== 1) {
        distributedSum += installmentValue;
      }

      newInstallments.push({
        index,
        numero_parcela: index + 1,
        data_venda: moment(proposalCrm?.created_at)
          .add(index * 30, "days")
          .format("YYYY-MM-DD"),
        valor_unitario:
          i !== 1
            ? MaskService.toMask("decimal", installmentValue.toFixed(2))
            : MaskService.toMask(
                "decimal",
                parseFloat(proposoalTotal - distributedSum).toFixed(2)
              ),
      });

      index++;
    }

    setGeneratedInstallments(newInstallments);
  }, [singlePaymentWay, setGeneratedInstallments, proposoalTotal]); // eslint-disable-line

  const isSingleCardPayment = useMemo(() => {
    const desc = (singlePaymentType?.descricao || "").toLowerCase();
    return desc.includes("cartao") || desc.includes("cartão");
  }, [singlePaymentType?.descricao]);

  const isRecurrentCardPayment = useMemo(() => {
    const desc = (recurrentPaymentType?.descricao || "").toLowerCase();
    return desc.includes("cartao") || desc.includes("cartão");
  }, [recurrentPaymentType?.descricao]);

  useEffect(() => {
    if (isSingleCardPayment) {
      setSingleBillingRuler(null);
    }
  }, [isSingleCardPayment, singleBillingRuler, setSingleBillingRuler]);

  useEffect(() => {
    if (isRecurrentCardPayment) {
      setRecurrentBillingRuler(null);
    }
  }, [isRecurrentCardPayment, recurrentBillingRuler, setRecurrentBillingRuler]);

  const handleClose = () => {
    handleClearContext();
    setRowEdit({});
  };

  return (
    <>
      {modalLeadOriginOpen && (
        <ModalCadastroDescricao
          open={modalLeadOriginOpen}
          setOpen={setModalLeadOriginOpen}
          title={
            leadOriginEditItem?.value
              ? "EDITAR ORIGEM DO LEAD"
              : "CADASTRAR ORIGEM DO LEAD"
          }
          editItem={leadOriginEditItem}
          onStore={storeLeadOrigin}
          onUpdate={updateLeadOrigin}
          onSaved={handleLeadOriginSaved}
        />
      )}
      {modalSaleTypeOpen && (
        <ModalCadastroDescricao
          open={modalSaleTypeOpen}
          setOpen={setModalSaleTypeOpen}
          title={
            saleTypeEditItem?.value
              ? "EDITAR TIPO DA VENDA"
              : "CADASTRAR TIPO DA VENDA"
          }
          editItem={saleTypeEditItem}
          onStore={storeSaleType}
          onUpdate={updateSaleType}
          onSaved={handleSaleTypeSaved}
        />
      )}
      
      {modalFinancialResponsibleOpen && (
        <SearchDialog
          open={modalFinancialResponsibleOpen}
          setOpen={setModalFinancialResponsibleOpen}
          columns={[
            { label: "CPF/CNPJ", id: "cpfcnpj" },
            { label: "Nome", id: "razao" },
          ]}
          selectable={true}
          multiSelect={false}
          handleMainClick={(setOpen, selected) => {
            setFinancialResponsibleInfos(selected[0] ?? null);
            setOpen(false);
          }}
          route="prouser/clientes/v1"
          title="RESPONSÁVEL FINANCEIRO"
          where={{ ativo: "S" }}
        />
      )}

      {modalSalesmanOpen && (
        <SearchDialog
          open={modalSalesmanOpen}
          setOpen={setModalSalesmanOpen}
          columns={[
            { label: "CPF/CNPJ", id: "cpfcnpj" },
            { label: "Nome", id: "nomevendedor" },
            { label: "Apelido", id: "apelido" },
          ]}
          selectable={true}
          multiSelect={false}
          handleMainClick={(setOpen, selected) => {
            setSalesmanInfos(selected[0] ?? null);
            setOpen(false);
          }}
          route="vendas/vendedores/v1"
          title="VENDEDORES"
          where={{ ativo: "S" }}
        />
      )}
      
      <Dialog maxWidth="md" open={true} onClose={handleClose}>
        <DialogTitle>
          {
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography>DETALHES DO CONTRATO</Typography>
              <Tooltip title="Fechar" placement="left">
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  size="small"
                >
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
          }
        </DialogTitle>
        <DialogContent>
          <GridStyled container spacing={3} $marginTop="20px">
            <Grid item xs={6}>
              <TextFieldErp
                disabled
                label="CPF/CNPJ"
                value={rowEdit?.cliente?.cpfcnpj || ""}
                setValue={() => {}}
                variant="filled"
                mask={
                  rowEdit?.cliente?.cpfcnpj.replace(/[^0-9]+/g, "").length > 11
                    ? "cnpj"
                    : "cpf"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <TextFieldErp
                disabled
                label="Razão"
                value={rowEdit?.cliente?.razao || ""}
                setValue={() => {}}
                variant="filled"
              />
            </Grid>

            <Grid item xs={6}>
              <TextFieldErp
                disabled
                label="Fantasia"
                value={rowEdit?.cliente?.apelido || ""}
                setValue={() => {}}
                variant="filled"
              />
            </Grid>

            <Grid item xs={3}>
              <TextFieldErp
                error={errors.proposalCode}
                helperText={errors.proposalCode}
                label="Código da Proposta"
                value={proposalCode}
                setValue={setProposalCode}
                maxLength={20}
                variant="filled"
              />
            </Grid>

            <Grid item xs={3}>
              <TextFieldErp
                label="Origem"
                value={originProposal}
                variant="filled"
                disabled
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!financialResponsibleEnabled}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setFinancialResponsibleEnabled(checked);
                      if (!checked) {
                        setFinancialResponsibleInfos(null);
                      }
                    }}
                    color="primary"
                  />
                }
                label="Responsável financeiro diferente do titular"
              />
            </Grid>
            {financialResponsibleEnabled && (
              <>
                <Grid item xs={5}>
                  <SearchSelect
                    getOptionLabel={(option) =>
                      `${option.cpfcnpj} - ${option.razao}`
                    }
                    label="Responsável Financeiro"
                    value={financialResponsibleInfos}
                    setValue={setFinancialResponsibleInfos}
                    route="prouser/clientes/v1"
                    filter="razao,apelido"
                    where={{ ativo: "S" }}
                    variant="filled"
                    onChange={(value) => setFinancialResponsibleInfos(value)}
                    customChange
                  />
                </Grid>
                <Grid item xs={1}>
                  <Btn
                    startIcon={<Icon>search</Icon>}
                    full="true"
                    onClick={() => setModalFinancialResponsibleOpen(true)}
                    bgcolor="tertiary"
                  />
                </Grid>
                <Grid item xs={6} />
              </>
            )}

            <Grid item xs={12} md={6}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs={10}>
                  <SearchSelect
                    descriptionField="apelido"
                    label="Vendedor"
                    value={salesmanInfos}
                    setValue={setSalesmanInfos}
                    route="vendas/vendedores/v1"
                    filter="nomevendedor,apelido"
                    where={{ ativo: "S" }}
                    variant="filled"
                  />
                </Grid>
                <Grid item xs={2}>
                  <Btn
                    startIcon={<Icon>search</Icon>}
                    full="true"
                    onClick={() => setModalSalesmanOpen(true)}
                    bgcolor="tertiary"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs={10} md={8}>
                  <SelectErp
                    label="Origem do Lead"
                    value={leadOrigin}
                    setValue={setLeadOrigin}
                    optionsList={listLeadOrigin}
                    loading={!!loadingsInputs.listLeadOrigin}
                    variant="filled"
                  />
                </Grid>
                <Grid item xs={1} md={2}>
                  <Btn
                    startIcon={<Add />}
                    full="true"
                    onClick={() => {
                      setLeadOriginEditItem(null);
                      setModalLeadOriginOpen(true);
                    }}
                    bgcolor="lightgreen"
                  />
                </Grid>
                <Grid item xs={1} md={2}>
                  <Btn
                    startIcon={<Edit />}
                    full="true"
                    onClick={async () => {
                      if (!leadOrigin?.id) return;

                      const confirmed = await confirmLookupEdit(
                        leadOrigin.descricao
                      );
                      if (!confirmed) return;

                      setLeadOriginEditItem({
                        value: leadOrigin.id,
                        label: leadOrigin.descricao,
                        descricao: leadOrigin.descricao,
                      });
                      setModalLeadOriginOpen(true);
                    }}
                    bgcolor="tertiary"
                    disabled={!leadOrigin?.id}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs={10} md={8}>
                  <SelectErp
                    label="Tipo da Venda"
                    value={saleType}
                    setValue={setSaleType}
                    optionsList={listSaleType}
                    loading={!!loadingsInputs.listSaleType}
                    variant="filled"
                  />
                </Grid>
                <Grid item xs={1} md={2}>
                  <Btn
                    startIcon={<Add />}
                    full="true"
                    onClick={() => {
                      setSaleTypeEditItem(null);
                      setModalSaleTypeOpen(true);
                    }}
                    bgcolor="lightgreen"
                  />
                </Grid>
                <Grid item xs={1} md={2}>
                  <Btn
                    startIcon={<Edit />}
                    full="true"
                    onClick={async () => {
                      if (!saleType?.id) return;

                      const confirmed = await confirmLookupEdit(
                        saleType.descricao
                      );
                      if (!confirmed) return;

                      setSaleTypeEditItem({
                        value: saleType.id,
                        label: saleType.descricao,
                        descricao: saleType.descricao,
                      });
                      setModalSaleTypeOpen(true);
                    }}
                    bgcolor="tertiary"
                    disabled={!saleType?.id}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid container item spacing={3}>
              {!!(proposalCrm?.proposal_products || []).find(
                (p) => p?.integration_details?.tiposervico === "A"
              ) && (
                <GridStyled item container xs={12}>
                  <Accordion
                    expanded={!!accordionsOpen.avulso}
                    onChange={() =>
                      setAccordionsOpen((current) => ({
                        ...current,
                        avulso: !current.avulso,
                      }))
                    }
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1bh-rowEdit"
                      id="panel1bh-header"
                    >
                      <Chip
                        bgcolor="secondary"
                        textcolor="black"
                        title
                        label="Serviços Avulsos"
                      />
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid item container spacing={2}>
                        <Grid item xs={12}>
                          <CardItemContract
                            items={proposalCrm?.proposal_products}
                            type="avulso"
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Card
                            chipcolor="transparent"
                            line="left"
                            lineColor="blue"
                            fullWidth={true}
                          >
                            <Grid item container spacing={1}>
                              <Grid
                                item
                                container
                                justifyContent="space-between"
                              >
                                <LabelStyled
                                  $fontFamily="Open Sans"
                                  $fontWeight="600"
                                  $fontSize="20px"
                                >
                                  Parcelas
                                </LabelStyled>
                              </Grid>

                              {(generatedInstallments || [])
                                .sort(
                                  (a, b) =>
                                    (a?.numero_parcela || 0) -
                                    (b?.numero_parcela || 0)
                                )
                                .map((installment, index) => (
                                  <Grid
                                    key={installment?.index || index}
                                    item
                                    container
                                    justifyContent="space-between"
                                    spacing={2}
                                    style={{ marginBottom: "5px" }}
                                  >
                                    <Grid
                                      item
                                      xs={6}
                                      container
                                      alignItems="center"
                                    >
                                      <Grid item xs={1}>
                                        <LabelStyled $fontFamily="Open Sans">
                                          <strong>{index + 1}ª</strong> -{" "}
                                        </LabelStyled>
                                      </Grid>

                                      <Grid item xs={6}>
                                        <TextFieldErp
                                          label=""
                                          type="date"
                                          value={installment?.data_venda}
                                          setValue={(value) => {
                                            setGeneratedInstallments(
                                              (current) => {
                                                const newInstallments = [
                                                  ...current,
                                                ];

                                                newInstallments[
                                                  index
                                                ].data_venda = value;

                                                return newInstallments;
                                              }
                                            );
                                          }}
                                        />
                                      </Grid>
                                    </Grid>

                                    <Grid item xs={3}>
                                      <TextFieldErp
                                        label=""
                                        value={installment?.valor_unitario}
                                        mask="decimal"
                                        startAdornment={
                                          <InputAdornment position="start">
                                            R$
                                          </InputAdornment>
                                        }
                                        setValue={(value) => {
                                          setGeneratedInstallments(
                                            (current) => {
                                              const newInstallments = [
                                                ...current,
                                              ];
                                              newInstallments[
                                                index
                                              ].valor_unitario = value;
                                              return newInstallments;
                                            }
                                          );
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                ))}
                            </Grid>
                          </Card>
                        </Grid>

                        <Grid item xs={12} container spacing={2}>
                          <Grid item xs={6}>
                            <SelectErp
                              error={errors.singleServiceType}
                              helperText={errors.singleServiceType}
                              label="Tipo de Serviço"
                              value={singleServiceType}
                              setValue={setSingleServiceType}
                              optionsList={contractTypeList}
                              loading={!!loadingsInputs.contractTypeList}
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <SelectErp
                              error={errors.singleRegimeCompetence}
                              helperText={errors.singleRegimeCompetence}
                              label="Regime de competência"
                              value={singleRegimeCompetence}
                              setValue={setSingleRegimeCompetence}
                              optionsList={competenceList}
                              descriptionField="label"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <TextFieldErp
                              error={errors.singleCompetenceDate}
                              helperText={errors.singleCompetenceDate}
                              label="Competência"
                              value={singleCompetenceDate}
                              setValue={setSingleCompetenceDate}
                              mask="month-and-year"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <SelectErp
                              error={errors.singlePaymentType}
                              helperText={errors.singlePaymentType}
                              label="Tipo de pagto"
                              value={singlePaymentType}
                              setValue={setSinglePaymentType}
                              optionsList={paymentTypeList}
                              loading={!!loadingsInputs.paymentTypeList}
                              descriptionField="descricao"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <SelectErp
                              error={errors.singlePaymentWay}
                              helperText={errors.singlePaymentWay}
                              label="Forma de pagto"
                              value={singlePaymentWay}
                              setValue={setSinglePaymentWay}
                              optionsList={paymentWayList}
                              loading={!!loadingsInputs.paymentWayList}
                              descriptionField="descricao"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <SelectErp
                              error={errors.singleBank}
                              helperText={errors.singleBank}
                              label="Banco/Agência"
                              value={singleBank}
                              setValue={setSingleBank}
                              optionsList={bankList}
                              loading={!!loadingsInputs.bankList}
                              descriptionField="apelido"
                            />
                          </Grid>

                          {singlePaymentType?.id ===
                            variablesModule.ERP_QYON
                              .TIPO_PAGAMENTO_BOLETO_ID && (
                            <Grid item xs={3}>
                              <SelectErp
                                error={errors.singleSlipType}
                                helperText={errors.singleSlipType}
                                label="Tipo de boleto"
                                descriptionField="label"
                                value={singleSlipType}
                                setValue={setSingleSlipType}
                                optionsList={slipTypesList}
                                loading={!!loadingsInputs.slipTypesList}
                              />
                            </Grid>
                          )}

                          <Grid item flex={1}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={singleNfse}
                                  onChange={() => {
                                    setSingleNfse((current) => !current);
                                  }}
                                  name="checkedB"
                                  color="primary"
                                />
                              }
                              label="Emitir Nota Fiscal de Serviço (NFS-e)"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <SelectErp
                              error={errors.singleBillingRuler}
                              helperText={errors.singleBillingRuler}
                              label="Régua de cobrança"
                              descriptionField="label"
                              value={singleBillingRuler}
                              setValue={setSingleBillingRuler}
                              optionsList={billingRulerList}
                              loading={!!loadingsInputs.billingRulerList}
                              disabled={isSingleCardPayment}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </GridStyled>
              )}

              {loadingModal && (
                <GridStyled
                  item
                  container
                  justifyContent="center"
                  $marginTop="20px"
                  $minWidth="895px"
                >
                  <CircularLoader />
                </GridStyled>
              )}

              {!!(proposalCrm?.proposal_products || []).find(
                (p) => p?.integration_details?.tiposervico === "R"
              ) && (
                <GridStyled $marginTop="20px" item container xs={12}>
                  <Accordion
                    expanded={!!accordionsOpen.recorrente}
                    onChange={() =>
                      setAccordionsOpen((current) => ({
                        ...current,
                        recorrente: !current.recorrente,
                      }))
                    }
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1bh-rowEdit"
                      id="panel1bh-header"
                    >
                      <Chip
                        bgcolor="secondary"
                        textcolor="black"
                        title
                        label="Serviços Recorrentes"
                      />
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid item container spacing={1}>
                        <Grid item xs={12}>
                          <CardItemContract
                            items={proposalCrm?.proposal_products}
                            type="recorrente"
                          />
                        </Grid>

                        <Grid item container spacing={2}>
                          <Grid item xs={6}>
                            <SelectErp
                              error={errors.recurrentServiceType}
                              helperText={errors.recurrentServiceType}
                              label="Tipo de Serviço"
                              value={recurrentServiceType}
                              setValue={setRecurrentServiceType}
                              optionsList={contractTypeList}
                              loading={!!loadingsInputs.contractTypeList}
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <TextFieldErp
                              error={errors.recurrentFirstMonthlyDate}
                              helperText={errors.recurrentFirstMonthlyDate}
                              label="Data 1ª Mensalidade"
                              type="date"
                              value={recurrentFirstMonthlyDate}
                              setValue={setRecurrentFirstMonthlyDate}
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <TextFieldErp
                              error={errors.recurrentExpirationDay}
                              helperText={errors.recurrentExpirationDay}
                              label="Dia Vencimento"
                              type="text"
                              value={recurrentExpirationDay}
                              setValue={setRecurrentExpirationDay}
                              maxLength={2}
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <SelectErp
                              error={errors.recurrentReadjustment}
                              helperText={errors.recurrentReadjustment}
                              label="Tipo de reajuste"
                              value={recurrentReadjustment}
                              setValue={setRecurrentReadjustment}
                              optionsList={readjustmentList}
                              loading={!!loadingsInputs.readjustmentList}
                              descriptionField="descricao"
                            />
                          </Grid>

                          <Grid item xs={6}>
                            <SelectErp
                              error={errors.recurrentRegimeCompetence}
                              helperText={errors.recurrentRegimeCompetence}
                              label="Regime de competência"
                              value={recurrentRegimeCompetence}
                              setValue={setRecurrentRegimeCompetence}
                              optionsList={competenceList}
                              descriptionField="label"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <TextFieldErp
                              error={errors.recurrentCompetenceDate}
                              helperText={errors.recurrentCompetenceDate}
                              label="Competência"
                              value={recurrentCompetenceDate}
                              setValue={setRecurrentCompetenceDate}
                              mask="month-and-year"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <TextFieldErp
                              error={errors.recurrentValidityDate}
                              helperText={errors.recurrentValidityDate}
                              label="Vigência (Renovação)"
                              value={recurrentValidityDate}
                              setValue={setRecurrentValidityDate}
                              mask="month-and-year"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <SelectErp
                              error={errors.recurrentPaymentType}
                              helperText={errors.recurrentPaymentType}
                              label="Tipo de pagto"
                              value={recurrentPaymentType}
                              setValue={setRecurrentPaymentType}
                              optionsList={paymentTypeList}
                              loading={!!loadingsInputs.paymentTypeList}
                              descriptionField="descricao"
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <SelectErp
                              error={errors.recurrentBank}
                              helperText={errors.recurrentBank}
                              label="Banco/Agência"
                              value={recurrentBank}
                              setValue={setRecurrentBank}
                              optionsList={bankList}
                              loading={!!loadingsInputs.bankList}
                              descriptionField="apelido"
                            />
                          </Grid>

                          {recurrentPaymentType?.id ===
                            variablesModule.ERP_QYON
                              .TIPO_PAGAMENTO_BOLETO_ID && (
                            <Grid item xs={3}>
                              <SelectErp
                                error={errors.recurrentSlipType}
                                helperText={errors.recurrentSlipType}
                                label="Tipo de boleto"
                                descriptionField="label"
                                value={recurrentSlipType}
                                setValue={setRecurrentSlipType}
                                optionsList={slipTypesList}
                                loading={!!loadingsInputs.slipTypesList}
                              />
                            </Grid>
                          )}

                          <Grid item xs={3}>
                            <SelectErp
                              error={errors.recurrentFrequency}
                              helperText={errors.recurrentFrequency}
                              label="Periodicidade"
                              value={recurrentFrequency}
                              setValue={setRecurrentFrequency}
                              optionsList={frequencyList}
                              descriptionField="label"
                            />
                          </Grid>

                          <Grid item flex={1}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={recurrentNfse}
                                  onChange={() => {
                                    setRecurrentNfse((current) => !current);
                                  }}
                                  name="checkedB"
                                  color="primary"
                                />
                              }
                              label="Emitir Nota Fiscal de Serviço (NFS-e)"
                            />
                          </Grid>

                          {!isRecurrentCardPayment && (
                            <Grid item xs={3}>
                              <SelectErp
                                error={errors.recurrentBillingRuler}
                                helperText={errors.recurrentBillingRuler}
                                label="Régua de cobrança"
                                descriptionField="label"
                                value={recurrentBillingRuler}
                                setValue={setRecurrentBillingRuler}
                                optionsList={billingRulerList}
                                loading={!!loadingsInputs.billingRulerList}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </GridStyled>
              )}
            </Grid>

            <Grid item container xs={12} alignItems="center" spacing={1}>
              <TypographyStyled
                $fontWeight="bold"
                $fontSize="18px"
                $color="blue"
                $fontFamily="opensans"
              >
                Data da Venda:
              </TypographyStyled>
              <Grid item flex={1}>
                <LabelStyled $fontFamily="Open Sans">
                  {proposalCrm?.created_at
                    ? formatDate({ date: proposalCrm?.created_at })
                    : ""}
                </LabelStyled>
              </Grid>
            </Grid>

            <Grid item container xs={12}>
              <TypographyStyled
                $fontWeight="bold"
                $fontSize="18px"
                $color="blue"
                $fontFamily="opensans"
              >
                Observação:
              </TypographyStyled>
              <Grid item xs={12}>
                <LabelStyled $fontFamily="Open Sans">
                  {proposalCrm?.observation || ""}
                </LabelStyled>
              </Grid>
            </Grid>
          </GridStyled>
        </DialogContent>
        <DialogActions>
          <Grid container alignItems="flex-end" justifyContent="flex-end">
            <GridStyled
              $padding="0 8px 0 0px"
              item
              container
              xs={3}
              alignItems="flex-end"
              justifyContent="center"
            >
              <GridStyled item xs={12} $padding="0 0 8px 0px">
                <TextFieldErp
                  error={errors.revisionDate}
                  helperText={errors.revisionDate}
                  label="Data Revisão"
                  type="date"
                  value={revisionDate}
                  setValue={setRevisionDate}
                />
              </GridStyled>

              <Grid item xs={12}>
                <Btn
                  full="true"
                  onClick={handleScheduling}
                  bgcolor="red"
                  label="Agendar Revisão"
                  hovercolor="blue"
                />
              </Grid>
            </GridStyled>
            {(() => {
              const loading = !!Object.entries(loadingsInputs).find(
                (i) => i[1]
              );

              return (
                <Btn
                  onClick={() => handleSubmit(proposalCrm)}
                  bgcolor="primary"
                  label={loading ? "Carregando" : "Aprovar"}
                  hovercolor="blue"
                  disabled={loading || !proposalCrm?.id}
                />
              );
            })()}
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalDetailTriagem;
